import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants";
import { FeedInsertSettings } from "../../content.types";

export const requestUpdateFeedInsertsSettings = async (
  feedInsertsSettings: FeedInsertSettings
): Promise<void> => {
  return await instance.put(
    ApiRoutesContent.FeedInsertsSettings,
    feedInsertsSettings
  );
};
